import { FC } from 'react';
import cx from 'classnames/bind';

import styles from './ButtonLink.module.scss';

interface ButtonLinkProps {
  text: string;
  handleClick: () => void;
  className?: string;
}

const cn = cx.bind(styles);

const ButtonLink: FC<ButtonLinkProps> = ({
  text,
  handleClick,
  className = '',
}) => (
  <button
    type="button"
    className={cn('button-link', className)}
    onClick={handleClick}
  >
    {text}
  </button>
);

export default ButtonLink;
